import React, { FC, PropsWithChildren } from 'react';
import { Box, Paper } from '@material-ui/core';


const FormContainer = ({ children }: PropsWithChildren) => {
  return (
    <Box paddingX={{ xs: 0, sm: 2, md: 10, lg: 14, xl: 20 }}>
      <Paper>
        <Box paddingX={2} paddingY={3}>
          {children}
        </Box>
      </Paper>
    </Box>
  );
};

export default FormContainer;
